import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRightIcon } from 'lucide-react';
interface CTABannerProps {
  /** Overrides the default headline. Falls back to the site-wide copy. */
  headline?: string;
  /** Overrides the button label. */
  buttonLabel?: string;
  /** Overrides the supporting sentence. */
  body?: string;
  onCtaClick?: () => void;
}
export function CTABanner({
  headline,
  buttonLabel,
  body,
  onCtaClick
}: CTABannerProps = {}) {
  return <section id="cta" className="relative w-full py-24 px-6 overflow-hidden" data-id="element-104" data-mp="2yy8f2dtzswin">
      {/* Gradient background */}
      <div className="absolute inset-0" style={{
      background: 'linear-gradient(135deg, #0D0B2E 0%, #1A1452 30%, #6C5CE7 70%, #C850C0 100%)'
    }} data-id="element-105" data-mp="2p254cjl2rpk3" />


      {/* Noise texture */}
      <div className="absolute inset-0 opacity-[0.04] pointer-events-none" style={{
      backgroundImage: "url(\"data:image/svg+xml,%3Csvg viewBox='0 0 256 256' xmlns='http://www.w3.org/2000/svg'%3E%3Cfilter id='noise'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.9' numOctaves='4' stitchTiles='stitch'/%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23noise)'/%3E%3C/svg%3E\")"
    }} data-id="element-106" data-mp="2k5oki1kwrxct" />


      <motion.div className="relative z-10 max-w-3xl mx-auto text-center" initial={{
      opacity: 0,
      y: 24
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true,
      margin: '-80px'
    }} transition={{
      duration: 0.6
    }} data-id="element-107" data-mp="n8hlcvqrb5pi">

        <span className="text-white/70 text-xs font-semibold tracking-[0.2em] uppercase block mb-4" data-id="element-108" data-mp="edtfp4h9rm06">
          Get started
        </span>
        <h2 className="text-3xl sm:text-5xl font-bold text-white tracking-tight mb-6" data-id="element-109" data-mp="4i9p8xlh5fit">
          {headline ?? 'Get something built today'}
        </h2>
        <p className="text-white/70 text-lg mb-10 max-w-xl mx-auto" data-id="element-110" data-mp="9egrogenw8w0">
          {body ?? 'Join manufacturing teams who replaced their legacy ERP with software that actually works for them.'}
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4" data-id="element-111" data-mp="3vpm6fcmcxsyq">
          <a href="https://calendly.com/alex-thruline/learn-about-thruline" onClick={onCtaClick} className="inline-flex items-center gap-2 min-h-[44px] px-8 py-3.5 rounded-full bg-white text-navy font-semibold text-sm hover:bg-white/90 transition-all hover:shadow-lg hover:shadow-white/10" data-id="element-112" data-mp="2275do98abn35">

            {buttonLabel ?? 'Get a Demo'}
            <ArrowRightIcon aria-hidden="true" className="w-4 h-4" data-id="element-113" data-mp="2l3oemb8xq4om" />
          </a>
        </div>
      </motion.div>
    </section>;
}